// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_95caa","message":"_0f907","icon":"c8bb6","error":"dabea","success":"_9de37","info":"d0ad5","text":"_1c276","button":"_60651","button-icon":"f3354","buttonIcon":"f3354"};